import { createFileRoute } from '@tanstack/react-router'
import { CasesPage } from '@bloo-team/product-vantage'
import type { CasesSearch } from '@bloo-team/product-vantage'

/**
 * Composer shim (S5.0, docs/modularization.md §Route mounting): route
 * infrastructure stays in the app's tree; the surface lives in
 * @bloo-team/product-vantage. `?case=` is an incoming link only (a case uuid
 * or a legacy id) — see docs/cases.md §Listing.
 */
function CasesRoute() {
  const { clusterId, scopeId } = Route.useParams()
  const search = Route.useSearch()
  return <CasesPage clusterId={clusterId} scopeId={scopeId} search={search} />
}

export const Route = createFileRoute('/$clusterId/$scopeId/vantage/cases')({
  validateSearch: (search: Record<string, unknown>): CasesSearch => ({
    ...(typeof search.case === 'string' && search.case ? { case: search.case } : {}),
  }),
  component: CasesRoute,
})
